/**
 * @returns A string with the first letter capitalized.
 */
export const capitalize = <W extends string>(word: W) =>
  `${word[0].toUpperCase()}${word.substring(1)}` as Capitalize<W>
